export default __webpack_public_path__ + "static/media/comingSoon.6e96e6ae.webp";